import { styled } from '@mui/material';

export const Container = styled('div')();

export const GenresContainer = styled('span')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const SectionA = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  position: 'relative',
}));

export const CertificationIconContainer = styled('div')(({ theme }) => ({
  left: '0',
  position: 'absolute',
  top: theme.spacing(0.5),
}));

export const RatingsContainer = styled('div')(() => ({
  display: 'flex',
}));

export const DetailsBody = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gridTemplateRows: 'min-content 1fr',
});

export const StillImageContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    gridColumnEnd: 5,
    marginBottom: theme.spacing(2),
    marginRight: 0,
    minWidth: '120px',
  },
  gridColumnEnd: 3,
  gridColumnStart: 1,
  gridRowEnd: 3,
  gridRowStart: 1,
  marginRight: theme.spacing(2),
  minWidth: '180px',
}));

export const StillImageOverviewContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    gridColumnStart: 1,
    gridRowStart: 'auto',
  },
  gridColumnEnd: 5,
  gridColumnStart: 3,
  gridRowStart: 1,
}));

export const PosterImageContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    gridColumnEnd: 3,
    minWidth: '120px',
  },
  gridColumnStart: 1,
  gridRowEnd: 3,
  gridRowStart: 1,
  marginRight: theme.spacing(2),
  minWidth: '180px',
}));

export const PosterImageOverviewContainer = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    gridColumnStart: 3,
  },
  gridColumnEnd: 5,
  gridColumnStart: 2,
  gridRowStart: 1,
}));

export const CastAndCrewHighlightsContainer = styled('div', { shouldForwardProp: prop => prop !== 'hasOverview' })<{
  hasOverview?: boolean;
}>(({ hasOverview, theme }) => ({
  ...(hasOverview
    ? {
        [theme.breakpoints.down('xl')]: {
          gridColumnStart: 1,
          gridRowStart: 3,
        },
        marginTop: theme.spacing(2),
      }
    : {}),
  gridColumnEnd: 5,
  gridColumnStart: 2,
  gridRowStart: 2,
}));

export const WatchProvidersHeadingContainer = styled('div')(() => ({
  alignItems: 'baseline',
  display: 'flex',
  justifyContent: 'space-between',
}));

export const PoweredBy = styled('span')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
  color: theme.supportingTextPrimary,
  fontSize: '0.75rem',
  marginRight: theme.spacing(1),
}));
